import { useDayzed } from 'dayzed';
import { useCallback, useState } from 'react';
import { getDateFromDateOrNow } from './shared';
const isClearingDateRange = (selectedDates, newDate) => {
    return selectedDates[0]?.getTime() === newDate.getTime() || selectedDates[1]?.getTime() === newDate.getTime();
};
export const calculateNewOffset = (selectedDates, newDate, initialDate, currentOffset) => {
    const currentEndDate = selectedDates?.slice(-1).pop();
    const shouldClearDateRange = isClearingDateRange(selectedDates, newDate);
    const dateToCalculateOffsetFrom = currentEndDate && !shouldClearDateRange ? currentEndDate : initialDate;
    if (!dateToCalculateOffsetFrom) {
        return currentOffset;
    }
    const monthDiff = dateToCalculateOffsetFrom.getMonth() -
        newDate.getMonth() +
        12 * (dateToCalculateOffsetFrom.getFullYear() - newDate.getFullYear());
    return currentOffset + monthDiff * (shouldClearDateRange ? -1 : 1);
};
export const useDatePicker = ({ date, minDate, maxDate, monthsToDisplay, selected, onDateSelected, }) => {
    const calculatedOffset = -((monthsToDisplay || 1) - 1);
    const [offset, setOffset] = useState(calculatedOffset);
    const [hoveredDate, setHoveredDate] = useState();
    const onOffsetChanged = useCallback((newOffset) => {
        setOffset(newOffset);
    }, []);
    const { calendars, getDateProps, getBackProps, getForwardProps } = useDayzed({
        date,
        minDate: minDate ? getDateFromDateOrNow(minDate) : undefined,
        maxDate: maxDate ? getDateFromDateOrNow(maxDate) : undefined,
        monthsToDisplay,
        offset,
        onOffsetChanged,
        selected,
        onDateSelected: (newDate) => {
            // reset the offset if a new end date is selected because they are linked in Dayzed mind
            setOffset((currentOffset) => calculateNewOffset(selected, newDate.date, date || new Date(), currentOffset));
            onDateSelected(newDate);
        },
    });
    const onDateMouseOver = ({ date: dateWithMouseEnter, selectable: isSelectable, }) => {
        setHoveredDate(isSelectable ? dateWithMouseEnter : undefined);
    };
    const onDateMouseOut = useCallback(({ date: dateWithMouseLeave }) => {
        if (hoveredDate && hoveredDate.getTime() === dateWithMouseLeave.getTime()) {
            setHoveredDate(undefined);
        }
    }, [hoveredDate]);
    return {
        calendars,
        getDateProps,
        getBackProps,
        getForwardProps,
        hoveredDate,
        onDateMouseOver,
        onDateMouseOut,
    };
};
